export const addLinkTagToString = ({
  string,
  trim = true,
}: {
  string: string;
  trim?: boolean;
}) => {
  const urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  return string.replace(urlRegex, (url) => {
    const fullurl = new URL(url);
    const pathName = fullurl.pathname;
    return `<a class="custom-link" href="${url}" target="_blank">${
      fullurl.hostname
    }${pathName.length > 5 ? `${pathName.substring(0, 5)}...` : pathName}</a>`;
  });
};

/** Matches absolute URLs and bare `www.` hosts, stopping before trailing punctuation. */
const LINK_REGEX =
  /((?:https?:\/\/|ftp:\/\/|www\.)[^\s<>()[\]{}]*[^\s<>()[\]{}.,:;!?'"])/gi;

export type TextSegment = { text: string; href?: string };

/**
 * Splits plain text into renderable segments, flagging the URL ones with an
 * `href`. Returns segments instead of an HTML string so callers can render
 * real anchors without `dangerouslySetInnerHTML`.
 */
export const splitTextWithLinks = (text: string): TextSegment[] => {
  if (!text) return [];
  const segments: TextSegment[] = [];
  let lastIndex = 0;
  // matchAll clones the regex, so the shared /g instance keeps a clean lastIndex.
  for (const match of text.matchAll(LINK_REGEX)) {
    const url = match[0];
    if (match.index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, match.index) });
    }
    segments.push({
      text: url,
      href: /^www\./i.test(url) ? `https://${url}` : url,
    });
    lastIndex = match.index + url.length;
  }
  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex) });
  }
  return segments;
};
